import { useSelector, useDispatch } from 'react-redux';
import { setConfirmedByUser, selectPristine, selectRequiresConfirmation } from '../app/reducers/paymentMethodChange'
import { useTranslation } from '../hooks/useTranslation';

export default function PaymentMethodConfirmation(){
  const dispatch = useDispatch();
  const requiresConfirmation = useSelector(selectRequiresConfirmation);
  const pristine = useSelector(selectPristine);
  const { t } = useTranslation();
  const selectResult = (result) => { dispatch(setConfirmedByUser(result)) }
  return (
    <div className={"loading-overlay "+(pristine ? 'pristine' : '')+(requiresConfirmation ? ' is-loading' : ' is-not-loading')}>
      {!pristine && <div className={"loading-detail"}>
        <div className={"modal-title"}>{t('modal.cancel_method')}</div>
        <div className={"modal-message"}>{t('modal.confirm_change_method')}</div>
        <div className={"modal-buttons"}>
          <button className={"modal-button"} onClick={()=>selectResult("NO")}>{t('common.no')}</button>
          <button className={"modal-button modal-button-highlighted"} onClick={()=>selectResult("OK")}>{t('common.yes')}</button>
        </div>
      </div>}
    </div>
  );
}